import { z } from "zod";
import { slugSchema } from "./slug";

export const entryStatusSchema = z.enum(["draft", "published"]);
export type EntryStatus = z.infer<typeof entryStatusSchema>;

/** Free-form content payload; validated against the content type's schema. */
export const entryDataSchema = z.record(z.string(), z.unknown());
export type EntryData = z.infer<typeof entryDataSchema>;

/** A content entry as returned by the API (reflects the DRAFT working copy by default). */
export const entrySchema = z
  .object({
    id: z.string(),
    typeId: z.string(),
    slug: slugSchema,
    data: entryDataSchema,
    status: entryStatusSchema,
    version: z.number().int().nonnegative(),
    publishedVersion: z.number().int().nonnegative().nullable(),
    hasUnpublishedChanges: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
    publishedAt: z.string().nullable(),
    updatedBy: z.string().nullable(),
    publishedBy: z.string().nullable(),
  })
  .strict();
export type Entry = z.infer<typeof entrySchema>;

export const createEntryInputSchema = z
  .object({
    slug: slugSchema.optional(),
    data: entryDataSchema,
  })
  .strict();
export type CreateEntryInput = z.infer<typeof createEntryInputSchema>;

export const updateEntryInputSchema = z
  .object({
    slug: slugSchema.optional(),
    data: entryDataSchema,
  })
  .strict();
export type UpdateEntryInput = z.infer<typeof updateEntryInputSchema>;
